module.exports = __webpack_public_path__ + "img/ry8.ac0537cb.jpeg";